import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
import { APCreditApplicationTargetParametersDto } from './ap-credit-application-target-parameters-dto';
import { DimensionOptionCodeRawDto } from '../../common/dimensions/dimension-option-code-raw-dto';

export class APApplyDebitParametersDto {
    communityId: number;
    managementCompanyId: number;
    sourceId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    applyDate: Date;

    @Type(() => APCreditApplicationTargetParametersDto)
    targets: Array<APCreditApplicationTargetParametersDto>;

    requiredDimensions: Array<DimensionOptionCodeRawDto>;
}
